import { Fallback } from '@/components/ErrorBoundary/Fallback/Fallback.tsx';
import { TranslationProvider } from '@/contexts/translation/TranslationProvider.tsx';
import { ErrorBoundary } from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { UserProvider } from '@/contexts/user/UserContext.tsx';

const queryClient = new QueryClient();

const rootElement = document.getElementById('react-root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <UserProvider>
        <ErrorBoundary fallback={<Fallback />}>
          <BrowserRouter>
            <QueryClientProvider client={queryClient}>
              <TranslationProvider>
                <App />
              </TranslationProvider>
            </QueryClientProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </UserProvider>
    </React.StrictMode>,
  );
}
